// extracted by mini-css-extract-plugin
export default {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","ImgResponsive":"bbv_a bho_a bho_q bho_j bho_wl bho_bj","ImgResponsive__img":"bbv_b bho_b bho_ql"};